import { render, staticRenderFns } from "./CourseStudentInfoPanel.vue?vue&type=template&id=3e4ffb86&scoped=true"
import script from "./CourseStudentInfoPanel.vue?vue&type=script&lang=js"
export * from "./CourseStudentInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./CourseStudentInfoPanel.vue?vue&type=style&index=0&id=3e4ffb86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ffb86",
  null
  
)

export default component.exports